import React from "react";
import List from "./List";
import DraggableWindow from "./DraggableWindow";
import Loading from "./Loading";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { motion } from "framer-motion";
import { Link, useParams } from 'react-router-dom';
import { ENDPOINTS, fetchWithLog } from '../config';
import './Skills.css';
const Skills = ({ visibility, functions, pageList, data, resetDrag }) => {
   // Use useParams to get the section parameter from the URL
   let { section } = useParams();
  const liClass = "skills-list";
  const headingClass = "skills-headings"
  const [loadPage, setLoadPage] = useState(false);
  const [skillBox, setSkillsBox] = useState(null);
  const resumeLink ="https://admin.mrakhudu.com/sites/default/files/Resume_Business_Analyst.pdf"
  const imageAnimationDuration = 2;
 
  const showSkillsSection = true// visibility.showSkills;
  var skillDict = {}
  var categoryIdsInOrder = [] // order from API (sort_order)
  //Download DATA
  const [content_data, setData] = useState(null);
    useEffect(() => {
      fetchWithLog(ENDPOINTS.skills)
        .then(response => response.json())
        .then(content_data =>{ setData(content_data)
          console.log("Results: "+JSON.stringify(content_data))
          skillDict = {}
          categoryIdsInOrder = []
          try{
            content_data.forEach(element => {
                  if (element.vid == "skills"){
                    element["subcategories"] = {}
                    element["subcategoryIdsInOrder"] = []
                    skillDict[element.tid] = element
                    categoryIdsInOrder.push(element.tid)
                    console.log("MAIN: "+element.title)
                  }
                  if (element.vid == "skills_subcategory"){
                    console.log("SUB: "+element.title + " cat: "+element.category)
                    element["skills"] = []
                    element["parent_id"] = element.category
                    skillDict[element.category]["subcategories"][element.tid]=element
                    skillDict[element.category]["subcategoryIdsInOrder"].push(element.tid)
                  }
                  if (element.vid == "skills_items"){
                    console.log("ITEM: "+element.title)
                    skillDict[element.category]["subcategories"][element.subcategory]["skills"].push(element)

                  }
              });  
            }catch (ex){
              console.log("Error: "+ex)
            } 
            console.log(JSON.stringify(skillDict))
            renderSkillsBox()
            setLoadPage(true)
        })
        .catch(error => console.error('Error fetching data:', error));
    }, []);
    //parse data - render ALL categories and subcategories in sort_order (from API / admin)
    function renderSkillsBox(){
      const categoryIds = categoryIdsInOrder.length ? categoryIdsInOrder : Object.keys(skillDict);
      console.log("Rendering "+ categoryIds)
      const allBoxes = categoryIds.map((item, index) => {
      const subIds = skillDict[item]?.subcategoryIdsInOrder?.length ? skillDict[item].subcategoryIdsInOrder : Object.keys(skillDict[item]?.subcategories || {});
      const subcategories = subIds.map(sid => skillDict[item].subcategories[sid]).filter(Boolean);
      return (
        <motion.div
          key={item}
          className="skillsBox"
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: imageAnimationDuration }}
          initial={{ y: -500, opacity: 0 }}
        >
          <div id={`layout-skills-${index}`}>
            <div className={index === 0 ? "layout-skills-col-1" : "layout-skills-col-2"}>
              <h4 className="skills-section-name">{skillDict[item]["title"]}</h4>
              <div className="row">
                {subcategories.map((skill, subIndex) => (
                  <div key={skill.tid || subIndex} className="col-md-6">
                    <h5>{skill.title}</h5>
                    <List
                      heading={skill.title}
                      headingClass={headingClass}
                      list={(skill.skills || []).map(skillItem => skillItem.title)}
                      ulClass=""
                      liClass={liClass}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      );});
      setSkillsBox(<div className="row">{allBoxes.map((box, i) => <div key={i} className="col-12 col-md-6 col-lg-4">{box}</div>)}</div>);
      return allBoxes;
    }

  return (
    <div id="skills" className="region region-skills">
      <div id="pageLoader" style={{opacity: loadPage ? 0: 1}}>
      <Loading  ></Loading>
      </div>
      <div id="content" style={{ display: showSkillsSection ? 'block' : 'none' }}>
        <div className="skills-header-wrapper">
          <div className="pageTitle" id="skillsPageTitle">
            <h1>SKILLS</h1>
            <h4 >WHAT I AM GOOD AT</h4>
          </div>
          <div className="skills-resume-wrapper">
            <DraggableWindow title={"Resume.pdf"} image={""} content={"Download My Resume"} type="resume" resumeLink = {resumeLink}
              loadPage={loadPage} resetDragVar={true} imageAnimationDuration = {imageAnimationDuration}/>
          </div>
        </div>
        <br></br>
        <div id='skillsContainer' className="row">
          {skillBox}
        </div>
      </div>
    </div>
  );
};

export default Skills;
